import { render, staticRenderFns } from "./BaseAnaliticaFies.vue?vue&type=template&id=05185ea8&scoped=true&"
import script from "./BaseAnaliticaFies.vue?vue&type=script&lang=js&"
export * from "./BaseAnaliticaFies.vue?vue&type=script&lang=js&"
import style0 from "./BaseAnaliticaFies.vue?vue&type=style&index=0&id=05185ea8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05185ea8",
  null
  
)

export default component.exports